<template>
  <legal-page
    title="Servicio al Cliente / Contacto"
    intro="Estamos a tu disposición para atender cualquier consulta, solicitud o reclamación relacionada con tus servicios o pagos."
  >
    <!-- Los datos iban como lista de filas etiqueta/valor separadas por líneas,
         que a lo ancho se leía como planilla. En mosaico cada dato es una pieza,
         y teléfono y correo quedan como acción y no como texto suelto. -->
    <div class="contact-grid">
      <div class="contact-tile">
        <div class="contact-tile__icon contact-tile__icon--primary">
          <feather-icon
            icon="BriefcaseIcon"
            size="18"
          />
        </div>
        <span class="contact-tile__label">Comercio</span>
        <span class="contact-tile__value">{{
          business.legalName
        }}</span>
      </div>

      <div class="contact-tile">
        <div class="contact-tile__icon contact-tile__icon--success">
          <feather-icon
            icon="PhoneIcon"
            size="18"
          />
        </div>
        <span class="contact-tile__label">Teléfono</span>
        <a
          class="contact-tile__value"
          :href="`tel:${business.phone}`"
        >{{ business.phone }}</a>
      </div>

      <div class="contact-tile">
        <div class="contact-tile__icon contact-tile__icon--info">
          <feather-icon
            icon="MailIcon"
            size="18"
          />
        </div>
        <span class="contact-tile__label">Correo electrónico</span>
        <a
          class="contact-tile__value"
          :href="`mailto:${business.email}`"
        >{{ business.email }}</a>
      </div>

      <div class="contact-tile">
        <div class="contact-tile__icon contact-tile__icon--warning">
          <feather-icon
            icon="MapPinIcon"
            size="18"
          />
        </div>
        <span class="contact-tile__label">Dirección</span>
        <span class="contact-tile__value">
          {{ business.municipality }} · {{ business.province }}<br>
          {{ business.postalCode }} · {{ business.country }}
        </span>
      </div>
    </div>

    <div class="legal-sections mt-1">
      <legal-section
        title="Horario de atención"
        icon="ClockIcon"
      >
        <p>
          Lunes a viernes de 8:00 a.m. a 6:00 p.m. · Sábados de 9:00
          a.m. a 1:00 p.m.
        </p>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection },
  data() {
    return { business }
  },
}
</script>

<style lang="scss" scoped>
.contact-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.contact-tile {
    padding: 1.375rem;
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius);
    background-color: var(--tm-surface);
}

.contact-tile__icon {
    width: 40px;
    height: 40px;
    margin-bottom: 0.875rem;
    border-radius: var(--tm-radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;

    &--primary {
        background-color: rgba(var(--tm-primary-rgb), var(--tm-tint));
        color: var(--tm-primary);
    }

    &--info {
        background-color: rgba(var(--tm-info-rgb), var(--tm-tint));
        color: var(--tm-info);
    }

    &--success {
        background-color: rgba(var(--tm-success-rgb), var(--tm-tint));
        color: var(--tm-success);
    }

    &--warning {
        background-color: rgba(var(--tm-warning-rgb), var(--tm-tint));
        color: var(--tm-warning);
    }
}

.contact-tile__label {
    display: block;
    font-size: 0.6875rem;
    font-weight: 600;
    color: var(--tm-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 0.125rem;
}

.contact-tile__value {
    display: block;
    font-size: 0.9375rem;
    font-weight: 600;
    color: var(--tm-text);
    line-height: 1.5;
    word-break: break-word;
}

// Teléfono y correo son accionables, pero el valor va en el mismo peso y color
// que el de "Comercio", así que sin el subrayado no se distinguen de un dato
// suelto. Es el mismo subrayado que ya llevan los enlaces de la prosa legal.
a.contact-tile__value {
    color: var(--tm-primary);
    text-decoration: underline;

    &:hover {
        color: var(--tm-primary-hover);
    }
}

@media (max-width: 576px) {
    .contact-grid {
        grid-template-columns: 1fr;
    }
}
</style>
